import React from 'react';
import { Table } from '../../../base/Table';

const PorchCell = ({ record, column, row }) => {
  return (
    <Table.BodyCell column={column} row={row} type="default">
      {record?.porch ?? '—'}
    </Table.BodyCell>
  );
};

export default PorchCell;
